import styled from 'styled-components';

export const BackdropStyled = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
`;

export const SuspenseLoaderStyled = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
`;
